module.exports = __webpack_public_path__ + "img/SAP_8874_l.c36d3233.jpg";